import set from 'lodash.set'
import { IApiConfig, IDomConfig } from './@types/config'
import { AppEvent } from './constants/events'
import { Components } from './helpers/components'
import { Config } from './helpers/config'
import { logger } from './helpers/logger'
import { Tracker } from './helpers/tracker'
import { Viewport } from './helpers/viewport'
import './styles'

// TODO: remove when `web-wrapper` replaces references with `window.$mediavine.video`
set(window, 'MediavineVideo.placement.render', init) // (Deprecated)
set(window, '$mediavine.video.render', init)

export function init(
  apiConfig: IApiConfig,
  domConfig: Partial<IDomConfig>
): void {
  try {
    Tracker.record(AppEvent.initPlacement, apiConfig)

    // prevent double-insertion of video
    // if (apiConfig.targetDiv && apiConfig.targetDiv.childNodes.length > 0) {
    //   logger.error('target div is already filled:', apiConfig.video.slug)
    //   return
    // }

    const config = new Config(apiConfig, domConfig)
    const components = new Components(config)
    const loadPlayer = async () => {
      try {
        const { Player } = await import('./helpers/player')
        await new Player(config, components).init()
      } catch (err) {
        logger.error('Problem loading Mediavine Video Player:', err)
      }
    }

    // lazyload background image
    // prettier-ignore
    const observer = new IntersectionObserver(([entry], self) => {
      if (!config.targetDiv) {
        self.unobserve(entry.target)
        return
      }

      const poster = config.playlist[config.startingPosition].poster
      const rootContainer = components.dom.rootContainer
      const titleBar = components.dom.titleBar._el
      const vidContainer = components.dom.videoContainer._el

      const titleBarOffset = getComputedStyle(titleBar).height
      const vidContainerHeight = getComputedStyle(vidContainer).height

      if (entry.isIntersecting) {
        rootContainer.style.backgroundImage = `url("${poster}")`
        rootContainer.style.backgroundSize = `100% ${vidContainerHeight}`
        rootContainer.style.backgroundPosition = `top ${titleBarOffset} right 0px`
        self.unobserve(entry.target)
      }
    }, {
      rootMargin: `0px 0px ${window.innerHeight}px 0px`,
      threshold: 0
    })
    observer.observe(config.targetDiv)

    // load the player immediately or on scroll
    if (Viewport.in(config.targetDiv)) {
      loadPlayer()
    } else {
      window.addEventListener('scroll', function _() {
        loadPlayer()
        window.removeEventListener('scroll', _)
      })
    }
  } catch (err) {
    logger.error('Problem rendering Mediavine Video placement:', err)
  }
}
